import Can from "components/Can/Can";
import { CENTRAL_DOACOES_PERMISSIONS } from "constants/index";
import { Form, Formik } from "formik";
import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "../../../components/Button/button.component";
import DropdownFilter from "../../../components/DropdownFilter/dropdownFilter.component";
import Table from "../../../components/Table/table.component";
import Title from "../../../components/Title/title.component";
import centralDoacaoService from "../../../services/centralDoacaoService";
import { validatePermission } from "../../../utils/permissionHelper";
import ToastHelper from "../../../utils/toastHelper";
import CancelarModal from "../../comum/modais/cancelar.modal";
import EditarModal from "./editar.modal";
import EditTransacaoEntradaModal from "./editTransacaoEntrada.modal";
import EditTransacaoSaidaModal from "./editTransacaoSaida.modal";
import EntradaModal from "./entrada.modal";
import PesquisaAvancada from "./pesquisaAvancadaHistoricoItemDoacao.component";
import SaidaModal from "./saida.modal";
import VisualizarTransacaoModal from "./visualizarTransacao.modal";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class GerenciarDoacoes extends Component {
	state = {
		doacao: { tipoItemDoacao: {} },
		doacaoId: 0,
		filtro: [],
		entrada: {},
		isOpenEntrada: false,
		isOpenSaida: false,
		isOpenEditar: false,
		isOpenEditTransacaoEntrada: false,
		isOpenEditTransacaoSaida: false,
		isOpenCancelarTransacao: false,
		isOpenVisualizarTransacao: false,
		itemSelecionado: { ...{} },
		historicoSelecionado: { tipoTransacao: "" },
		pesquisaSimplificada: true
	};

	setFieldValue = undefined;

	columns = [
		{ id: 0, title: "Transação", property: "tipoTransacaoNome" },
		{ id: 1, title: "Saldo anterior", property: "quantidadeAnterior" },
		{ id: 2, title: "Entrada/Saída", property: "quantidade" },
		{ id: 3, title: "Saldo atual", property: "saldo" },
		{ id: 4, title: "Data de saída", property: "dataSaida" },
		{ id: 5, title: "Destino", property: "destino" }
	];

	showGerenciar() {
		const { usuario } = this.props;
		return validatePermission(
			CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTIDADE,
			usuario.soeAcoes
		);
	}

	get actions() {
		return [
			{
				id: 0,
				name: "Visualizar",
				icon: "fas fa-search",
				action: item => this.handleVisualizarTransacao(item.id)
			},
			{
				id: 1,
				name: "Editar",
				icon: "fas fa-edit",
				action: () => this.handleEditTransacao(),
				enabled: item => {
					const { historicos, doacao } = this.state;
					return (
						historicos[0].id === doacao.ultimoIdHistorico &&
						!item.cancelado &&
						historicos[0].id === item.id
					);
				},
				checkRule: true,
				show: this.showGerenciar.bind(this)
			},
			{
				id: 2,
				name: "Cancelar",
				icon: "fas fa-times",
				action: () => this.handleCancelTransacao(),
				enabled: item => {
					const { historicos, doacao } = this.state;
					return (
						historicos[0].id === doacao.ultimoIdHistorico &&
						!item.cancelado &&
						historicos[0].id === item.id
					);
				},
				checkRule: true,
				show: this.showGerenciar.bind(this)
			}
		];
	}

	componentDidMount() {
		this.initialize();
		this.pesquisaAvancadaRef = React.createRef();
	}

	handleVoltar = () => {
		const { history } = this.props;
		history.push("/centralDoacoes/listaDoacoes");
	};

	/*
		MODAL EDITAR TRANSAÇÂO
	*/

	handleEditTransacao = () => {
		const { historicos } = this.state;
		if (historicos[0].tipoTransacao === "ENTRADA") {
			this.setState({ isOpenEditTransacaoEntrada: true });
		} else {
			this.setState({ isOpenEditTransacaoSaida: true });
		}
	};

	handleCloseEditTransacao = () => {
		this.setState({ isOpenEditTransacaoEntrada: false });
		this.setState({ isOpenEditTransacaoSaida: false });
	};

	handleSubmitEditTransacao = async values => {
		await centralDoacaoService.editarTransacao(values);
		ToastHelper.success("Edição concluída com sucesso.");
		this.initialize();
	};

	createModalEditTransacaoEntrada = (
		item,
		{ doacao, isOpenEditTransacaoEntrada }
	) =>
		isOpenEditTransacaoEntrada && (
			<EditTransacaoEntradaModal
				isOpenEditar={isOpenEditTransacaoEntrada}
				handleCloseEdit={this.handleCloseEditTransacao}
				handleSubmitEdit={this.handleSubmitEditTransacao}
				transacao={item}
				nomeItem={doacao.unidadeDeExibicao}
			/>
		);

	createModalEditTransacaoSaida = (
		item,
		{ doacao, isOpenEditTransacaoSaida }
	) =>
		isOpenEditTransacaoSaida && (
			<EditTransacaoSaidaModal
				isOpenEditar={isOpenEditTransacaoSaida}
				handleCloseEdit={this.handleCloseEditTransacao}
				handleSubmitEdit={this.handleSubmitEditTransacao}
				transacao={item}
				nomeItem={doacao.unidadeDeExibicao}
			/>
		);

	/*
		MODAL CANCELAR TRANSAÇÂO
	*/
	handleCancelTransacao = () => {
		this.setState({ isOpenCancelarTransacao: true });
	};

	createCancelarModal = transacao => {
		const { isOpenCancelarTransacao } = this.state;
		return (
			isOpenCancelarTransacao && (
				<CancelarModal
					isOpenCancelar={isOpenCancelarTransacao}
					handleCloseCancelar={() =>
						this.setState(prevState => ({
							prevState,
							isOpenCancelarTransacao: false
						}))
					}
					handleSubmitCancelar={async () => {
						await centralDoacaoService.cancelarTransacao(transacao);
						ToastHelper.success("Transação cancelada com sucesso.");
						this.initialize();
						this.setState(prevState => ({
							prevState,
							isOpenCancelarTransacao: false
						}));
					}}
				/>
			)
		);
	};

	/*
		MODAL ENTRADA
	*/
	handleOpenModalEntrada = () => {
		this.setState({ isOpenEntrada: true });
	};

	handleCloseEntrada = () => {
		this.setState({ isOpenEntrada: false });
	};

	handleSalvarEntrada = async values => {
		await centralDoacaoService.salvarEntradaDoacao(values);
		ToastHelper.success("Doação cadastrada com sucesso.");
		this.initialize();
	};

	createModalEntrada = item =>
		this.state.isOpenEntrada && (
			<EntradaModal
				isOpenEntrada={this.state.isOpenEntrada}
				handleCloseEntrada={this.handleCloseEntrada}
				handleSalvarEntrada={this.handleSalvarEntrada}
				doacaoId={item.id}
				nomeItem={item.unidadeDeExibicao}
			/>
		);

	/*
		MODAL SAÍDA
	*/
	handleOpenModalSaida = () => {
		this.setState({ isOpenSaida: true });
	};

	handleCloseSaida = () => {
		this.setState({ isOpenSaida: false });
	};

	handleSalvarSaida = async values => {
		await centralDoacaoService.salvarSaidaDoacao(values);
		ToastHelper.success("Saída cadastrada com sucesso.");
		this.initialize();
	};

	createModalSaida = item =>
		this.state.isOpenSaida && (
			<SaidaModal
				isOpenSaida={this.state.isOpenSaida}
				handleCloseSaida={this.handleCloseSaida}
				handleSalvarSaida={this.handleSalvarSaida}
				doacaoId={item.id}
				nomeItem={item.unidadeDeExibicao}
			/>
		);

	/*
		MODAL EDITAR ESTOQUE
	*/
	handleOpenModalEditar = () => {
		this.setState({ isOpenEditar: true });
	};

	handleCloseEditar = () => {
		this.setState({ isOpenEditar: false });
	};

	handleSubmitEditar = async values => {
		await centralDoacaoService.cadastraDoacao(values);
		ToastHelper.success("Edição concluída com sucesso.");
		this.initialize();
	};

	createModalEditar = (item, { isOpenEditar }) =>
		isOpenEditar && (
			<EditarModal
				isOpenEditar={isOpenEditar}
				handleCloseEditar={this.handleCloseEditar}
				handleSubmitEditar={this.handleSubmitEditar}
				item={item}
			/>
		);

	/*
		MODAL VISUALIZAR TRANSAÇÂO
	*/
	handleCloseVisualizarTransacao = () => {
		this.setState({ isOpenVisualizarTransacao: false });
	};

	createModalVisualizarTransacao = () => {
		const { isOpenVisualizarTransacao, historicoSelecionado } = this.state;
		return (
			isOpenVisualizarTransacao && (
				<VisualizarTransacaoModal
					isOpenVisualizar={isOpenVisualizarTransacao}
					handleCloseVisualizarTransacao={
						this.handleCloseVisualizarTransacao
					}
					transacao={historicoSelecionado}
				/>
			)
		);
	};

	async handleVisualizarTransacao(idHistorico) {
		const response = await centralDoacaoService.findHistoricoById(
			idHistorico
		);
		this.setState({ historicoSelecionado: response.data });
		this.setState({ isOpenVisualizarTransacao: true });
	}

	header(doacao) {
		const saldo = doacao.quantidade !== null ? doacao.quantidade : "--";
		return (
			<div className="row">
				<div className="col-md-12">
					<div className="row">
						<div className="col-md-4 pb-3">
							<b>Código:</b> {doacao.id}
						</div>
						<div className="col-md-5 pb-3">
							<b>Item:</b> {doacao.unidadeDeExibicao}
						</div>
						<div className="col-md-3 d-flex align-items-start justify-content-end">
							<Can
								perform={
									CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ITEM
								}
								yes={() => (
									<Button
										primary
										type="button"
										text="Editar item"
										onClick={this.handleOpenModalEditar}
										icon="fas fa-edit"
									/>
								)}
								no={() => <span />}
							/>
						</div>
						<div className="col-md-4 pb-3">
							<b>Tipo do item:</b> {doacao.tipoItemDoacao.nome}
						</div>
						<div className="col-md-8 pb-3">
							<b>Quantidade em estoque:</b> {saldo}
						</div>
					</div>
				</div>
			</div>
		);
	}

	handleChangeCheckboxGroup(value) {
		const transacoes = value.map(f => f.id);
		this.updateList({ transacoes, simplificado: true });
	}

	pesquisaSimplificada() {
		const initialValues = {
			transacao: [
				{ id: "ENTRADA", nome: "Entrada" },
				{ id: "SAIDA", nome: "Saída" }
			]
		};

		return (
			this.state.pesquisaSimplificada && (
				<div className="col-12 pr-0">
					<Formik
						initialValues={initialValues}
						enableReinitialize
						onSubmit={this.handleSubmit}
						render={({ setFieldValue, values, errors }) => {
							this.setFieldValue = setFieldValue;
							return (
								<Form>
									<div className="row mt-1">
										<div className="col-12">
											<DropdownFilter
												keyName="transacao"
												id="transacao"
												name="transacao"
												aroundAlign
												filtro={values.transacao || []}
												checkboxValuesList={[
													{
														id: "ENTRADA",
														nome: "Entrada"
													},
													{
														id: "SAIDA",
														nome: "Saída"
													}
												]}
												error={errors.transacao}
												setFieldValue={setFieldValue}
												handleChangeCheckboxGroup={value =>
													this.handleChangeCheckboxGroup(
														value
													)
												}
											/>
										</div>
									</div>
								</Form>
							);
						}}
					/>
				</div>
			)
		);
	}

	pesquisaAvancada() {
		const { pesquisaSimplificada } = this.state;
		return (
			!pesquisaSimplificada && (
				<PesquisaAvancada
					buttonLabel="Voltar"
					handleReset={() => {
						this.updateList({ transacoes: [] });
					}}
					handleSearch={values => {
						this.updateList({
							...values,
							transacoes: values.transacoes.map(
								transacao => transacao.value
							),
							simplificado: false
						});
					}}
					handlePesquisaSimplificada={() => {
						this.updateList({ transacoes: [] });
						this.setState({ pesquisaSimplificada: true });
					}}
					ref={this.pesquisaAvancadaRef}
				/>
			)
		);
	}

	historico(historicos) {
		const {
			pesquisaSimplificada,
			paginaHistoricoAtualConteudo,
			paginaHistoricoAtual,
			historicoPaginas,
			totalElementsHistorico
		} = this.state;
		return (
			<div className="col-md-12">
				<div className="card">
					<div className="card-header">Histórico de transações</div>
					<div className="row container mt-3 d-flex align-items-center justify-content-between">
						<div
							className={
								pesquisaSimplificada ? "col-md-4" : "col-md-12"
							}
						>
							<Can
								perform={
									CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTRADA
								}
								yes={() => (
									<Button
										type="button"
										size="sm"
										primary
										icon="fas fa-plus"
										text="Entrada"
										onClick={this.handleOpenModalEntrada}
									/>
								)}
								no={() => <span />}
							/>

							<Can
								perform={
									CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_SAIDA
								}
								yes={() => (
									<Button
										type="button"
										size="sm"
										primary
										icon="fas fa-minus"
										text="Saída"
										onClick={this.handleOpenModalSaida}
									/>
								)}
								no={() => <span />}
							/>
						</div>
						<div
							className={
								pesquisaSimplificada ? "col-5" : "col-md-12"
							}
						>
							{this.pesquisaAvancada()}
							{this.pesquisaSimplificada()}
						</div>
					</div>
					{pesquisaSimplificada && (
						<div className="col-12">
							<button
								className="btn btn-link pl-0 mt-3"
								type="button"
								onClick={() => {
									this.updateList({ transacoes: [] });
									this.setState({
										pesquisaSimplificada: false
									});
								}}
							>
								Pesquisa avançada
							</button>
						</div>
					)}
					<div className="row container mt-3 mb-3">
						<Table
							align="left"
							columns={this.columns}
							actions={this.actions}
							data={paginaHistoricoAtualConteudo}
							onChangePage={n =>
								this.setState(prevState => ({
									paginaHistoricoAtual: n,
									paginaHistoricoAtualConteudo: historicos.slice(
										n * prevState.itemsPorPagina,
										(n + 1) * prevState.itemsPorPagina
									)
								}))
							}
							currentPage={paginaHistoricoAtual}
							emptyMessage="Não há itens cadastrados. "
							emptyColSpan={
								this.actions.length > 0
									? this.columns.length + 1
									: this.columns.length
							}
							totalPages={historicoPaginas}
							showPaginate={
								!historicos ? false : historicos.length > 0
							}
							totalElements={totalElementsHistorico}
							totalItemPages={
								typeof paginaHistoricoAtualConteudo ===
								"undefined"
									? 0
									: paginaHistoricoAtualConteudo.length
							}
							trClass={historico =>
								historico.cancelado ? "cancelado" : ""
							}
							permission={CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR}
						/>
					</div>
				</div>
			</div>
		);
	}

	footer() {
		return (
			<div className="col-6">
				<div className="row">
					<div className="col-md-12">
						<div className="float-left ">
							<Button
								primary
								type="button"
								text="Voltar"
								onClick={this.handleVoltar}
								icon="fas fa-arrow-left"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	async updateList(filter) {
		const { doacaoId } = this.state;
		const { data } = await centralDoacaoService.findByIdAndTransacoes(
			doacaoId,
			filter
		);
		const itemsPorPagina = 15;

		const paginaHistoricoAtual = 0;
		const historicoPaginas = Math.ceil(
			data.historicos.length / itemsPorPagina
		);
		this.setState({
			historicos: data.historicos,
			itemsPorPagina,

			totalElementsHistorico: data.historicos.length,

			historicoPaginas,
			paginaHistoricoAtual,
			paginaHistoricoAtualConteudo: data.historicos.slice(
				paginaHistoricoAtual,
				paginaHistoricoAtual + itemsPorPagina
			),
			doacao: data
		});
	}

	initialize() {
		if (this.pesquisaAvancadaRef && this.pesquisaAvancadaRef.current) {
			this.pesquisaAvancadaRef.current.resetForm();
		}
		const {
			match: { params }
		} = this.props;

		this.setState({ doacaoId: params.id }, () =>
			this.updateList({
				transacoes: ["ENTRADA", "SAIDA"],
				simplificado: true
			})
		);

		this.setState({ isOpenEntrada: false });
		this.setState({ isOpenSaida: false });
		this.setState({ isOpenEditar: false });
		this.setState({ isOpenEditTransacaoEntrada: false });
		this.setState({ isOpenEditTransacaoSaida: false });
		this.setFieldValue("transacao", [
			{ id: "ENTRADA", nome: "Entrada" },
			{ id: "SAIDA", nome: "Saída" }
		]);
	}

	render() {
		const { historicos, doacao } = this.state;

		return (
			<div>
				<div className="row">
					<div className="col-md-12">
						<Can
							perform={[
								CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ITEM,
								CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTIDADE,
								CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_ENTRADA,
								CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_OFICIO,
								CENTRAL_DOACOES_PERMISSIONS.GERENCIAR_SAIDA
							]}
							yes={() => <Title>Gerenciar item</Title>}
							no={() => <Title>Visualizar item</Title>}
						/>
					</div>
				</div>

				<div className="card container">
					<div className="card-body">
						{this.header(doacao)}
						<div className="row mt-2">
							{this.historico(historicos)}
						</div>
						<div className="row mt-2">{this.footer()}</div>
					</div>
				</div>
				{this.createModalSaida(doacao)}
				{this.createModalEntrada(doacao)}
				{this.createModalEditar(doacao, this.state)}
				{this.createCancelarModal(historicos ? historicos[0] : null)}
				{this.createModalEditTransacaoEntrada(
					historicos ? historicos[0] : null,
					this.state
				)}
				{this.createModalEditTransacaoSaida(
					historicos ? historicos[0] : null,
					this.state
				)}
				{this.createModalVisualizarTransacao()}
			</div>
		);
	}
}

export default connect(mapStateToProps)(GerenciarDoacoes);
